export const reportConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getOutletReports_request: "getOutletReports_request",
        getOutletReports_success: "getOutletReports_success",
        getOutletReports_failure: "getOutletReports_failure",    
    }

    let obj_formatted = {};
    let domain = "billingPortal.report/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}